import { logDebugging } from '../log/logger';
import { getDomainFromUrl, getHostName, getParentUrlOrigin } from '../utils/urlUtils';

/* eslint-disable no-param-reassign */
const tappxkeySelector = [
  {
    domain: 'www.elplural.com',
    tappxKey: {
      mweb: 'pub-78631-mweb-1049',
      desktop: 'pub-78632-desktop-1088',
    },
    endpoint: 'js42380pl',
  },
];

export function updateTappxKeyConfig(config) {
  // eslint-disable-next-line no-undef
  const [origin] = [getDomainFromUrl(getParentUrlOrigin())];
  const tappxkeySelected = tappxkeySelector.find((item) => item.domain === getHostName(origin));
  if (tappxkeySelected) {
    logDebugging('TappxKey changed to ', tappxkeySelected.tappxKey);
    config.tappxKey = tappxkeySelected.tappxKey;
    config.endpoint = tappxkeySelected.endpoint;
  }
}

export default tappxkeySelector;
